import {
  Text,
  Flex,
  Box
} from '@chakra-ui/react';
import MainLayout from 'components/mainLayout';
import Topbar from "components/topbar";

const TermsAndConditions = () => {
  return (
    <MainLayout>
      <Box height={"100%"}>
        <Topbar title={"Terms and Conditions"} />
        <Flex bg={"#f8fbff"} padding={4}>
          <Box flex={1} bg={"white"} padding={8} borderRadius={16}>
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              REGISTRATION
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              All sellers are pre-approved and authorised by Kidswear
              Collective. Sellers can either send items to our business premises
              or we can arrange collection. A collection fee of £5.95 will be
              deducted from the seller’s account balance.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              Accepted items include designer baby, boys and girls wear from
              newborn to 14 years, in addition to shoes and accessories. As a
              guideline, a typical item would have had a minimum retail price of
              at least £40 or higher.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={10}
            >
              Pre-worn (also known as pre-loved) items must be in pristine
              condition or gently worn with no visible signs of wear. We do not
              accept items with stains, tears or worn or over washed fabric.
              Unworn (also known as past season) items must include their
              original tags.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              ITEM CONSIGNMENT
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              All pre-worn items received by Kidswear Collective are inspected
              for wear and tear and stains, as well as suitability. Rejected
              items will be sent to our charity partners, unless otherwise
              requested and returned to the seller. A return fee of £2.95 per
              item will be deducted from the seller’s account balance at
              Kidswear Collective.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              All pre-worn items are sent for cleaning (unless they have already
              been cleaned and include the cleaning tags). Kidswear Collective
              has negotiated discounted business rates. Dry cleaning costs are
              £3.95 for garments and £5.50 for outerwear. Some items may cost
              more to clean or repair and if this is the case, Kidswear
              Collective will inform the seller in advance for authorisation.
              Cleaning costs are deducted from the seller’s account balance.
            </Text>
            {/* STORAGE */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              STORAGE
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              All items are professionally photographed and listed on the
              Kidswear Collective website. They are individually listed with
              style descriptions and categorised by various features.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Sellers send items at their own risk and Kidswear Collective is
              not liable for any damages, loss or theft for items in transit or
              held in storage or off-site at pop-ups, tradeshows or cleaners.
            </Text>
            {/* PRICING */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              PRICING
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              The seller’s share is 50% of the sale price (minus any cleaning,
              collection or return related costs as covered above).
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              Kidswear Collective has full discretion on the sale price for each
              item, which is typically 55% off the original retail price and
              discounts can go up to 80%, depending on the quality of the
              garment and time taken to sell.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Kidswear Collective reserves the right to reduce item sale prices
              after a reasonable period of time if they have not sold and can
              continue to reduce prices until such time that they are eventually
              sold. Similarly, if items are subsequently found to have stains or
              damaged they will be removed from inventory.
            </Text>
            {/* PROMOTIONS */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              PROMOTIONS
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Items are promoted on Kidswear Collective from time to time and
              any additional discounts (such as discount codes) are deducted
              from Kidswear Collective’s share of the sale proceeds, rather than
              the seller’s.
            </Text>
            {/* PAYMENTS */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              PAYMENTS
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Net proceeds from sales (as noted above) will be paid to sellers
              at the end of each month following a 30 day return period.
              Payments will be made by direct bank transfer. Payments will
              typically be paid when account balances are above £50.
            </Text>
            {/* STATEMENTS */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              STATEMENTS
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Sellers receive a statement upon request. This includes the value
              of stock received, sold and remaining. It also shows the total
              amount paid out to the seller.
            </Text>
            {/* ACCEPTANCE */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"uppercase"}
              color={"#000000"}
              textAlign={"center"}
              mb={4}
            >
              ACCEPTANCE
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              mb={8}
            >
              Sending items to Kidswear Collective will be deemed as acceptance
              of the seller’s terms and conditions as listed above.
            </Text>
          </Box>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export default TermsAndConditions;